import { InjectionToken } from '@angular/core';

export const incomeSource = {
  '01': 'Nómina o pensión',
  '02': 'Mi empresa o negocio',
  '03': 'Rentas inmobiliarias',
  '04': 'Renta del capital',
  '05': 'Presataciones sociales',
  '06': 'Otros: Herencias, loterías',
  '07': 'Préstamo'
} as const;

export type IncomeSource = typeof incomeSource;

export const INCOME_SOURCE = new InjectionToken('INCOME_SOURCE', {
  providedIn: 'root',
  factory: () => incomeSource
});
